import React from 'react';

const TechnologyStack = () => {
  const allTechnologies = [
    { name: 'React', category: 'Frontend', color: '#61DAFB' },
    { name: 'Next.js', category: 'Frontend', color: '#000000' },
    { name: 'Vue.js', category: 'Frontend', color: '#4FC08D' },
    { name: 'TypeScript', category: 'Frontend', color: '#3178C6' },
    { name: 'Angular', category: 'Frontend', color: '#DD0031' },
    { name: 'Node.js', category: 'Backend', color: '#339933' },
    { name: 'Python', category: 'Backend', color: '#3776AB' },
    { name: 'Java', category: 'Backend', color: '#ED8B00' },
    { name: 'Go', category: 'Backend', color: '#00ADD8' },
    { name: 'PHP', category: 'Backend', color: '#777BB4' },
    { name: 'React Native', category: 'Mobile', color: '#61DAFB' },
    { name: 'Flutter', category: 'Mobile', color: '#02569B' },
    { name: 'Swift', category: 'Mobile', color: '#FA7343' },
    { name: 'Kotlin', category: 'Mobile', color: '#7F52FF' },
    { name: 'Ionic', category: 'Mobile', color: '#3880FF' },
    { name: 'AWS', category: 'Cloud & DevOps', color: '#FF9900' },
    { name: 'Azure', category: 'Cloud & DevOps', color: '#0078D4' },
    { name: 'Docker', category: 'Cloud & DevOps', color: '#2496ED' },
    { name: 'Kubernetes', category: 'Cloud & DevOps', color: '#326CE5' },
    { name: 'CI/CD', category: 'Cloud & DevOps', color: '#FF6B35' },
    { name: 'PostgreSQL', category: 'Databases', color: '#336791' },
    { name: 'MongoDB', category: 'Databases', color: '#47A248' },
    { name: 'MySQL', category: 'Databases', color: '#4479A1' },
    { name: 'Redis', category: 'Databases', color: '#DC382D' },
    { name: 'Elasticsearch', category: 'Databases', color: '#005571' },
    { name: 'Git', category: 'Tools & Others', color: '#F05032' },
    { name: 'GraphQL', category: 'Tools & Others', color: '#E10098' },
    { name: 'Microservices', category: 'Tools & Others', color: '#FF6B35' },
    { name: 'AI/ML', category: 'Tools & Others', color: '#4A90E2' },
    { name: 'Terraform', category: 'Tools & Others', color: '#7B42BC' },
    { name: 'Prometheus', category: 'Tools & Others', color: '#E6522C' },
    { name: 'LangChain', category: 'Tools & Others', color: '#1C3C3C' },
    { name: 'OpenAI API', category: 'Tools & Others', color: '#10A37F' },
    { name: 'Blockchain', category: 'Tools & Others', color: '#F7931A' }
  ];

  const categories = ['Frontend', 'Backend', 'Mobile', 'Cloud & DevOps', 'Databases', 'Tools & Others'];

  return (
    <section id="technology" className="technology-section-redesigned">
      <div className="container">
        <div className="section-header-modern">
          <span className="section-label-modern">Technology Stack</span>
          <h2 className="section-title-modern">Stack for scale, security &amp; automation</h2>
          <p className="section-description-modern">
            From application stacks to cloud, data, AI, and observability—we use proven tools across AWS and Azure, automation, and security-conscious delivery so your estate stays maintainable.
          </p>
        </div>

        <div className="tech-categories-filter">
          {categories.map((category) => (
            <button key={category} className="category-filter-btn" data-category={category.toLowerCase().replace(/\s+/g, '-')}>
              {category}
            </button>
          ))}
        </div>

        <div className="tech-tags-container">
          {allTechnologies.map((tech, index) => (
            <div
              key={index}
              className="tech-tag-badge reveal-on-scroll reveal-fade-up"
              data-category={tech.category.toLowerCase().replace(/\s+/g, '-')}
              style={{ '--tech-color': tech.color, '--delay': `${index * 0.05}s`, borderColor: tech.color }}
            >
              <span className="tech-tag-name">{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologyStack;

